import React, { useEffect, useState } from "react";
import { Element } from "@craftjs/core";
import { Container } from "../../components/user/Container";
import { Text } from "../../components/user/Text";
import { Image } from "../../components/user/Image";
import { ResponsiveContainer } from "../../components/user/ResponsiveContainer";

export const HeroSection = () => {
  // Detect if we're in preview mode - we'll use window location or other method
  const [isPreview, setIsPreview] = useState(false);

  useEffect(() => {
    // Check if we're in preview mode based on URL or other methods
    const inPreview = window.location.pathname.includes("preview");
    setIsPreview(inPreview);
  }, []);

  // Handle form submission in preview mode
  const handleSubmit = () => {
    if (isPreview) {
      alert("Phone number submitted!");
      // Could add navigation: window.location.href = '/success';
    }
  };

  // Handle link clicks in preview mode
  const handleLinkClick = (route: string) => {
    if (isPreview) {
      alert(`Navigating to ${route}`);
      // Could add navigation: window.location.href = route;
    }
  };

  return (
    <Element
      id="hero_section_container"
      canvas
      is={Container}
      background="#f5f5f5"
      height="auto"
      className="hero-section"
      padding="20px"
      margin="0"
      borderRadius={0}
      width="100%"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Element
        id="hero_section_responsive_wrapper"
        canvas
        is={ResponsiveContainer}
        className="hero-responsive-wrapper"
        padding="0"
        margin="0"
        // Mobile styles (column layout)
        mobileStyles={{
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
        // Tablet styles (still column for small tablets)
        tabletStyles={{
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
        // Laptop and Desktop styles (row layout)
        laptopStyles={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
        desktopStyles={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Element
          id="hero_content_container"
          canvas
          is={Container}
          className="hero-content"
          background="transparent"
          padding="20px"
          margin="0"
          borderRadius={0}
          // Full width on mobile, 50% on larger screens
          width="100%"
          height="auto"
          flexDirection="column"
          alignItems="flex-start"
          justifyContent="center"
        >
          <Text
            text="Get Access To Your Mobile"
            fontSize={36}
            color="#000000"
            fontWeight="bold"
            textAlign="left"
            className="hero-title"
            margin="0 0 20px 0"
            padding="0"
          />

          <Element
            id="hero_step_1_container"
            canvas
            is={Container}
            background="transparent"
            padding="0"
            margin="0 0 10px 0"
            borderRadius={0}
            width="100%"
            height="auto"
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-start"
          >
            <Element
              id="hero_step_1_circle"
              canvas
              is={Container}
              background="#3b82f6"
              padding="0"
              margin="0 10px 0 0"
              borderRadius={50}
              width="30px"
              height="30px"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
            >
              <Text
                text="1"
                fontSize={16}
                color="#ffffff"
                fontWeight="bold"
                textAlign="center"
                margin="0"
                padding="0"
              />
            </Element>
            <Text
              text="Enter your mobile phone number"
              fontSize={16}
              color="#000000"
              fontWeight="normal"
              textAlign="left"
              margin="0"
              padding="0"
            />
          </Element>

          <Element
            id="hero_step_2_container"
            canvas
            is={Container}
            background="transparent"
            padding="0"
            margin="0 0 20px 0"
            borderRadius={0}
            width="100%"
            height="auto"
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-start"
          >
            <Element
              id="hero_step_2_circle"
              canvas
              is={Container}
              background="#9ca3af"
              padding="0"
              margin="0 10px 0 0"
              borderRadius={50}
              width="30px"
              height="30px"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
            >
              <Text
                text="2"
                fontSize={16}
                color="#ffffff"
                fontWeight="bold"
                textAlign="center"
                margin="0"
                padding="0"
              />
            </Element>
            <Text
              text="Send an SMS with the correct keyword after number verification"
              fontSize={16}
              color="#4b5563"
              fontWeight="normal"
              textAlign="left"
              margin="0"
              padding="0"
            />
          </Element>

          <Text
            text="Enter your mobile number to start downloading now:"
            fontSize={18}
            color="#000000"
            fontWeight="bold"
            textAlign="left"
            margin="0 0 10px 0"
            padding="0"
          />

          <Element
            id="hero_phone_input"
            canvas
            is={Container}
            background="#ffffff"
            padding="10px"
            margin="0 0 15px 0"
            borderRadius={5}
            width="100%"
            height="auto"
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-start"
            border="1px solid #3b82f6"
          >
            <Element
              id="hero_phone_icon"
              canvas
              is={Container}
              background="transparent"
              padding="0"
              margin="0 10px 0 0"
              borderRadius={0}
              width="auto"
              height="auto"
            >
              <Text
                text="📱"
                fontSize={20}
                color="#000000"
                fontWeight="normal"
                textAlign="center"
                margin="0"
                padding="0"
              />
            </Element>

            {/* Real input field - invisible in editor, visible in preview */}
            <input
              type="tel"
              placeholder="Enter your phone number"
              defaultValue="6"
              style={{
                fontSize: "18px",
                color: "#000000",
                border: "none",
                outline: "none",
                width: "100%",
                background: "transparent",
                fontFamily: "inherit",
                display: isPreview ? "block" : "none",
              }}
            />

            {/* Text component - visible in editor, hidden in preview */}
            {!isPreview && (
              <Text
                text="6"
                fontSize={18}
                color="#000000"
                fontWeight="normal"
                textAlign="left"
                margin="0"
                padding="0"
              />
            )}
          </Element>

          <Element
            id="hero_continue_button"
            canvas
            is={Container}
            background="#3b82f6"
            padding="15px"
            margin="0 0 15px 0"
            borderRadius={5}
            width="100%"
            height="auto"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            style={{ cursor: isPreview ? "pointer" : "default" }}
            onClick={isPreview ? handleSubmit : undefined}
          >
            <Text
              text="CONTINUE"
              fontSize={18}
              color="#ffffff"
              fontWeight="bold"
              textAlign="center"
              margin="0"
              padding="0"
            />
          </Element>

          <Text
            text="Weekly subscription for 4.20 EUR. Cancel? Text STOP GAMING to 1335. Tele2 and Telia users will pay a one-time fee of 10 EUR for 14 days of service."
            fontSize={14}
            color="#000000"
            fontWeight="normal"
            textAlign="left"
            margin="0 0 15px 0"
            padding="0"
          />

          <Text
            text="Discover the world's best mobile gaming platform"
            fontSize={18}
            color="#000000"
            fontWeight="bold"
            textAlign="left"
            margin="0 0 10px 0"
            padding="0"
          />

          <Text
            text="This is the Gamingclub gaming service provided by Sam Media BV (parent company of Prizeflix BV). For Bite users: you will be charged EUR 4.20 each week and your subscription will automatically renew. For Tele 2 and Telia users: you will be charged EUR 10 per message and will be available for two weeks. These charges will be charged from your prepaid balance at the start of your subscription and weekly thereafter or will be added to your monthly mobile phone bill for this phone. Text messaging charges apply according to your operator's standard rates. You can opt out of the service by sending an SMS message STOP GAMING to 1335. Operator data charges may apply depending on your plan. You must be at least 18 years of age to access the service. By registering and/or using the service, you acknowledge and confirm that you have read the terms and conditions and the privacy policy, that you are 18 years of age or older and that you are the mobile account owner or have the consent of the mobile account owner. If you have any questions, you can contact customer support by phone +37052078310 or by email.This service is provided by Sam Media (parent company of Prizeflix BV), Van Diemenstraat 356, 1013CR - Amsterdam, The Netherlands."
            fontSize={12}
            color="#4b5563"
            fontWeight="normal"
            textAlign="left"
            margin="0 0 10px 0"
            padding="0"
          />

          <Text
            text="help@thegamingclub-lt.com"
            fontSize={12}
            color="#4b5563"
            fontWeight="normal"
            textAlign="left"
            margin="0 0 10px 0"
            padding="0"
          />

          <Element
            id="hero_links_container"
            canvas
            is={Container}
            background="transparent"
            padding="0"
            margin="0"
            borderRadius={0}
            width="100%"
            height="auto"
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-start"
            gap="10px"
          >
            <Text
              text="Terms"
              fontSize={12}
              color="#3b82f6"
              fontWeight="normal"
              textAlign="left"
              margin="0"
              padding="0"
              style={{ cursor: isPreview ? "pointer" : "default" }}
              onClick={isPreview ? () => handleLinkClick("/terms") : undefined}
            />
            <Text
              text="Help"
              fontSize={12}
              color="#3b82f6"
              fontWeight="normal"
              textAlign="left"
              margin="0"
              padding="0"
              style={{ cursor: isPreview ? "pointer" : "default" }}
              onClick={isPreview ? () => handleLinkClick("/help") : undefined}
            />
            <Text
              text="Imprint"
              fontSize={12}
              color="#3b82f6"
              fontWeight="normal"
              textAlign="left"
              margin="0"
              padding="0"
              style={{ cursor: isPreview ? "pointer" : "default" }}
              onClick={
                isPreview ? () => handleLinkClick("/imprint") : undefined
              }
            />
            <Text
              text="Manage subscription"
              fontSize={12}
              color="#3b82f6"
              fontWeight="normal"
              textAlign="left"
              margin="0"
              padding="0"
              style={{ cursor: isPreview ? "pointer" : "default" }}
              onClick={isPreview ? () => handleLinkClick("/manage") : undefined}
            />
          </Element>

          <Element
            id="hero_agreement_container"
            canvas
            is={Container}
            background="transparent"
            padding="0"
            margin="10px 0 0 0"
            borderRadius={0}
            width="auto"
            height="auto"
            flexDirection="row"
            alignItems="center"
            justifyContent="flex-start"
          >
            <Element
              id="hero_checkbox"
              canvas
              is={Container}
              background="#f0f0f0"
              padding="2px"
              margin="0 10px 0 0"
              borderRadius={2}
              width="20px"
              height="20px"
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
              border="1px solid #9ca3af"
              style={{ cursor: isPreview ? "pointer" : "default" }}
            >
              <Text
                text="✓"
                fontSize={14}
                color="#000000"
                fontWeight="bold"
                textAlign="center"
                margin="0"
                padding="0"
              />
            </Element>
            <Text
              text="I agree that after the trial period ends, my subscription will"
              fontSize={12}
              color="#4b5563"
              fontWeight="normal"
              textAlign="left"
              margin="0"
              padding="0"
            />
          </Element>
        </Element>

        <Element
          id="hero_image_container"
          canvas
          is={Container}
          background="transparent"
          padding="0"
          // Add top margin for mobile to separate from content
          margin="20px 0 0 0"
          borderRadius={0}
          // Full width on mobile, 45% on larger screens
          width="100%"
          height="auto"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Image
            src="https://thegamingclub-lt.com/os-ui/static/lt-thegamingclub-msisdn-cmp-nid/files/813258ebb50776a29582..jpg"
            width="100%"
            height="auto"
            margin="0"
            padding="0"
            borderRadius={8}
            alt="Gamer with arms raised in celebration"
          />
        </Element>
      </Element>
    </Element>
  );
};
